export default angular.module('eventix.common.services.beforeUnload',[])
/**
 * @ngdoc service
 * @name eventix.common.services.beforeUnload
 * @kind function
 * @description
 * Add an event listener on beforeUnload
 *
 * @param {Function} fn Function to execute before unloading page
 * @returns {Function} Deregister function
 */
    .factory('beforeUnload', function($window) {
        var callbacks = [];

        if($window.addEventListener)
            $window.addEventListener('beforeunload', beforeunload);
        else
            $window.attachEvent('onbeforeunload', beforeunload);

        var Interface = function(fn) {
            callbacks.push(fn);
            return () => _.pull(callbacks, fn);
        };

        /**
     * @ngdoc method
     * @name eventix.common.services.beforeUnload#clear
     * @methodOf eventix.common.services.beforeUnload
     * @description
     * Clear all callbacks
     */
        Interface.clear = () => {
            callbacks = [];
        };
        return Interface;

        /**
     * Run all the callbacks
     *
     * @param {Event} event Window event
     * @returns {Any} Returns the first non-void value returned by the callbacks
     */
        function beforeunload(event) {
            var returnValues = [];
            for(var i = 0; i < callbacks.length; i++)
                returnValues.push(callbacks[i](event));
            returnValues = _.compact(returnValues);
            if(returnValues.length)
                return returnValues[0];
            return undefined;
        }
    }).name;
